import { Container } from '../../../styles/Common';
import QuoteForm from './QuoteForm';
import { Wrapper, InnerMain, LeftImage, RightSide } from './Styles';

const RequestAQuote = () => {
  return (
    <Wrapper>
      <Container>
        <InnerMain>
          <LeftImage>
            <img
              src="/assets/images/request-a-quote-left-image.png"
              alt="request-a-quote"
            />
          </LeftImage>
          <RightSide>
            <QuoteForm />
          </RightSide>
        </InnerMain>
      </Container>
    </Wrapper>
  );
};

export default RequestAQuote;
